import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-511bc312"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-col-ter-ard" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "form-text"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 1,
  class: "flex-col"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  style: {"width":"80%"}
}
const _hoisted_8 = { class: "text-ct" }
const _hoisted_9 = { class: "fail" }
const _hoisted_10 = { class: "ft-w-6 text-ct" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { reactive, watch } from 'vue'
import useForm from '@/util/useForm'
import { t } from '@/plugins/i18n'
import UploadFile from '@/components/common/UploadFile.vue'
import UploadImg from '@/components/common/UploadImg.vue'
import Tooltip from '@/components/common/Tooltip.vue'
import ColorPick from './ColorPick.vue'
import InfoTable from './InfoTable.vue'
import AddSku from './AddSku.vue'
import PrintLogo from './PrintLogo.vue'
import createRules from '../model/rules'

export default /*#__PURE__*/_defineComponent({
  props: ['node', 'data'],
  emits: ['next'],
  setup(__props, { expose, emit }) {

const props = __props
// todo：模板改为 JSX



const model = reactive(props.node.data)
watch(model, (val) => {
  const props: any = []
  Object.entries(val).forEach(([k, v]) => {
    // 空值或空数组则不校验
    if (v && v?.length !== 0) {
      props.push(k)
    }
  })
  // 先clear
  props.length && formRef.value && formRef.value.validateField(props)
})

const [formRef, commit, valid] = useForm(() => {
  const { next } = props.node
  emit('next', next)
})
expose({ valid })

const rules = createRules(props, model)

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)(__props.node.title)), 1),
    (!__props.node.fail)
      ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          model: _unref(model),
          ref: (_value, _refs) => {
            _refs['formRef'] = _value
            _isRef(formRef) && (formRef.value = _value)
          },
          rules: _unref(rules)
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                (!!__props.node.table)
                  ? (_openBlock(), _createBlock(InfoTable, _mergeProps({ key: 0 }, __props.node.table, { data: __props.data }), null, 16, ["data"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.node.items, (v, i) => {
              return (_openBlock(), _createBlock(_component_el_form_item, {
                key: v.key || v.label,
                prop: v.key,
                class: _normalizeClass({ wide: v.wide }),
                label: i + 1 + '. ' + _unref(t)(v.label)
              }, {
                default: _withCtx(() => [
                  _createVNode(Tooltip, {
                    tooltip: v.tooltip,
                    "tip-option": v.tipOption
                  }, {
                    default: _withCtx(() => [
                      (v.type === 'text')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.text.split('##'), (line, i) => {
                              return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(line), 1))
                            }), 128))
                          ]))
                        : (v.type === 'download')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (!v.list)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: v.url,
                                    class: "fcolor"
                                  }, _toDisplayString(_unref(t)(v.text)), 9, _hoisted_4))
                                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.list, (item) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: item.url,
                                        href: item.url,
                                        target: "_blank",
                                        class: "fcolor"
                                      }, _toDisplayString(_unref(t)(item.text)), 9, _hoisted_6))
                                    }), 128))
                                  ]))
                            ], 64))
                          : (v.type === 'input')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (v.trim)
                                  ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                      key: 0,
                                      modelValue: _unref(model)[v.key],
                                      "onUpdate:modelValue": ($event: any) => ((_unref(model)[v.key]) = $event),
                                      modelModifiers: { trim: true },
                                      placeholder: v.placeholder ? _unref(t)(v.placeholder) : ''
                                    }, v.options), null, 16, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                                  : (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                      key: 1,
                                      modelValue: _unref(model)[v.key],
                                      "onUpdate:modelValue": ($event: any) => ((_unref(model)[v.key]) = $event),
                                      placeholder: v.placeholder ? _unref(t)(v.placeholder) : ''
                                    }, v.options), null, 16, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                              ], 64))
                            : (v.type === 'textarea')
                              ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                  key: 3,
                                  type: "textarea",
                                  rows: 3,
                                  placeholder: v.placeholder ? _unref(t)(v.placeholder) : ''
                                }, v.options, {
                                  modelValue: _unref(model)[v.key],
                                  "onUpdate:modelValue": ($event: any) => ((_unref(model)[v.key]) = $event)
                                }), null, 16, ["placeholder", "modelValue", "onUpdate:modelValue"]))
                              : (v.type === 'number')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                    _createVNode(_component_el_input_number, _mergeProps({
                                      class: "num-unit",
                                      modelValue: _unref(model)[v.key],
                                      "onUpdate:modelValue": ($event: any) => ((_unref(model)[v.key]) = $event),
                                      min: 0.001,
                                      max: 100000,
                                      controls: false
                                    }, v.options), null, 16, ["modelValue", "onUpdate:modelValue", "min"]),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)(v.unit)), 1)
                                  ], 64))
                                : (v.type === 'checkbox-group')
                                  ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                                      key: 5,
                                      modelValue: _unref(model)[v.key],
                                      "onUpdate:modelValue": ($event: any) => ((_unref(model)[v.key]) = $event)
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.list, (item, i) => {
                                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                                            key: i,
                                            label: item.label
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_unref(t)(item.label)), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["label"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                  : (v.type === 'date')
                                    ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
                                        key: 6,
                                        type: "date",
                                        modelValue: _unref(model)[v.key],
                                        "onUpdate:modelValue": ($event: any) => ((_unref(model)[v.key]) = $event),
                                        "value-format": "YYYY-MM-DD"
                                      }, v.options), null, 16, ["modelValue", "onUpdate:modelValue"]))
                                    : (v.type === 'file')
                                      ? (_openBlock(), _createBlock(UploadFile, {
                                          key: 7,
                                          url: _unref(model)[v.key],
                                          "onUpdate:url": ($event: any) => ((_unref(model)[v.key]) = $event),
                                          filename: v.filename,
                                          "onUpdate:filename": ($event: any) => ((v.filename) = $event)
                                        }, null, 8, ["url", "onUpdate:url", "filename", "onUpdate:filename"]))
                                      : (v.type === 'image')
                                        ? (_openBlock(), _createBlock(UploadImg, {
                                            key: 8,
                                            img: _unref(model)[v.key],
                                            onChange: (img) => (_unref(model)[v.key] = img)
                                          }, null, 8, ["img", "onChange"]))
                                        : (v.type === 'color-card')
                                          ? (_openBlock(), _createBlock(ColorPick, {
                                              key: 9,
                                              colors: _unref(model).colorCard,
                                              "onUpdate:colors": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).colorCard) = $event))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(UploadImg, {
                                                  img: _unref(model).colorCardUrl,
                                                  onChange: _cache[0] || (_cache[0] = (img) => (_unref(model).colorCardUrl = img))
                                                }, null, 8, ["img"])
                                              ]),
                                              _: 1
                                            }, 8, ["colors"]))
                                          : (v.type === 'radio')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                                                _createVNode(_component_el_radio_group, {
                                                  modelValue: _unref(model)[v.key],
                                                  "onUpdate:modelValue": ($event: any) => ((_unref(model)[v.key]) = $event)
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.tabs, (r) => {
                                                      return (_openBlock(), _createBlock(_component_el_radio, {
                                                        key: r.value,
                                                        label: r.value
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(Tooltip, {
                                                            tooltip: r.tooltip,
                                                            "tip-option": r.tipOption
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(r.labelJP ? r.labelJP : _unref(t)(r.label)), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["tooltip", "tip-option"])
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["label"]))
                                                    }), 128))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                                (_unref(model)[v.key] === v.customKey)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.custom, (v) => {
                                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                                          key: v.type
                                                        }, [
                                                          _createElementVNode("div", null, _toDisplayString(_unref(t)(v.label)), 1),
                                                          (v.type === 'textarea')
                                                            ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                                                key: 0,
                                                                type: "textarea",
                                                                rows: 3,
                                                                placeholder: v.placeholder ? _unref(t)(v.placeholder) : ''
                                                              }, v.options, {
                                                                modelValue: _unref(model)[v.key],
                                                                "onUpdate:modelValue": ($event: any) => ((_unref(model)[v.key]) = $event)
                                                              }), null, 16, ["placeholder", "modelValue", "onUpdate:modelValue"]))
                                                            : (v.type === 'image')
                                                              ? (_openBlock(), _createBlock(UploadImg, {
                                                                  key: 1,
                                                                  img: _unref(model)[v.key],
                                                                  onChange: (img) => (_unref(model)[v.key] = img)
                                                                }, null, 8, ["img", "onChange"]))
                                                              : (v.type === 'print-logo')
                                                                ? (_openBlock(), _createBlock(PrintLogo, {
                                                                    key: 2,
                                                                    modelValue: _unref(model)[v.key],
                                                                    "onUpdate:modelValue": ($event: any) => ((_unref(model)[v.key]) = $event),
                                                                    data: __props.data
                                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "data"]))
                                                                : _createCommentVNode("", true)
                                                        ], 64))
                                                      }), 128))
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                            : (v.type === 'add-sku')
                                              ? (_openBlock(), _createBlock(AddSku, {
                                                  key: 11,
                                                  list: _unref(model)[v.key],
                                                  "onUpdate:list": ($event: any) => ((_unref(model)[v.key]) = $event),
                                                  data: __props.data
                                                }, null, 8, ["list", "onUpdate:list", "data"]))
                                              : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["tooltip", "tip-option"])
                ]),
                _: 2
              }, 1032, ["prop", "class", "label"]))
            }), 128)),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(Tooltip, {
                tooltip: __props.node.tooltip
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "commit",
                    round: "",
                    type: "primary",
                    onClick: _unref(commit)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.node.end
            ? _unref(t)(__props.data.searchSourceOrderId ? '重新创建寻源单' : '创建寻源单')
            : _unref(t)('提交')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["tooltip"])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("a", {
                href: __props.node.url,
                class: "fcolor"
              }, _toDisplayString(_unref(t)('您可以点击此处')) + "， ", 9, _hoisted_11),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('使用THE CKB帮助您制作式样书')), 1)
            ])
          ]),
          _hoisted_13,
          _hoisted_14
        ], 64))
  ]))
}
}

})